import React, { useState, useEffect } from 'react';
import axios from '../../../services/api';
import { FaTimes, FaEdit, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import CreateEntranceModal from './CreateEntranceModal';
import DeleteConfirmModal from '../../../components/modals/ConfirmModal';
import { useTranslation } from 'react-i18next';

const EntranceModal = ({ isOpen, onClose, community, onSuccess }) => {
  const { t } = useTranslation();
  const [entrances, setEntrances] = useState([]);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [selectedEntrance, setSelectedEntrance] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  useEffect(() => {
    if (isOpen && community) {
      fetchEntrances();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, community]);
    // eslint-disable-next-line react-hooks/exhaustive-deps

  const fetchEntrances = async () => {
    try {
      const response = await axios.get(`/entrances/${community._id}`);
      setEntrances(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-end pr-[10%] pt-[5%] z-50">
      <div className="bg-white w-[60vw] h-[70vh] rounded-lg shadow-xl flex flex-col">
        <div className="bg-black text-white px-4 py-3 rounded-t-lg flex justify-between items-center">
          <h2 className="text-lg font-semibold">{t('Entrance')}</h2>
          <button onClick={onClose} className="text-white/70 hover:text-white transition-colors">
            <FaTimes />
          </button>
        </div>

        <div className={`${entrances.length > 0 ? 'overflow-auto' : 'overflow-hidden'} relative flex-1 mt-2 px-2`}>
          <table className="w-full">
            <thead className="sticky top-0 z-30 bg-skin-primary shadow-sm">
              <tr className="border-b border-skin-base/10">
                <th className="px-4 py-2 text-left font-semibold text-skin-base">{t('No')}</th>
                <th className="px-4 py-2 text-left font-semibold text-skin-base">{t('Entrance ID')}</th>
                <th className="px-4 py-2 text-left font-semibold text-skin-base">{t('Entrance Name')}</th>
                <th className="px-4 py-2 text-left font-semibold text-skin-base w-[100px] text-right">{t('Actions')}</th>
              </tr>
            </thead>
            <tbody>
              {entrances.map((entrance, index) => (
                <tr key={entrance._id}>
                  <td className="px-4 py-2 whitespace-nowrap border-b border-gray-200">{index + 1}</td>
                  <td className="px-4 py-2 whitespace-nowrap border-b border-gray-200">{entrance.entranceId}</td>
                  <td className="px-4 py-2 whitespace-nowrap border-b border-gray-200">{entrance.entranceName}</td>
                  <td className="px-4 py-2 whitespace-nowrap border-b border-gray-200">
                    <div className="flex items-center gap-2 justify-end">
                      <button
                        onClick={() => {
                          setSelectedEntrance(entrance);
                          setIsCreateModalOpen(true);
                        }}
                        className="text-gray-600 hover:text-gray-900"
                      >
                        <FaEdit />
                      </button>
                      <button
                        onClick={() => {
                          setSelectedEntrance(entrance);
                          setIsDeleteModalOpen(true);
                        }}
                        className="text-gray-600 hover:text-gray-900"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="p-4 border-t border-gray-200 flex justify-end">
          <button
            onClick={() => {
              setSelectedEntrance(null);
              setIsCreateModalOpen(true);
            }}
            className="px-4 py-1.5 border border-gray-300 rounded bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            {t('Create New')}
          </button>
        </div>

        <CreateEntranceModal
          isOpen={isCreateModalOpen}
          onClose={() => {
            setIsCreateModalOpen(false);
            setSelectedEntrance(null);
          }}
          community={community}
          entrance={selectedEntrance}
          onSuccess={()=>{
            fetchEntrances();
            onSuccess();
          }}
        />

        <DeleteConfirmModal
          isOpen={isDeleteModalOpen}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setSelectedEntrance(null);
          }}
          onConfirm={async () => {
            try {
              await axios.delete(`/entrances/${selectedEntrance._id}`);
              toast.success(t('Entrance deleted successfully'));
              setIsDeleteModalOpen(false);
              setSelectedEntrance(null);
              fetchEntrances();
              onSuccess();
            } catch (error) {
              toast.error(t('Entrance delete error'));
            }
          }}
          title={t('Delete Entrance')}
          message={t('Are you sure you want to delete this entrance? This action cannot be undone.')}
        />
      </div>
    </div>
  );
};

export default EntranceModal;
